
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { SEO } from "@/components/SEO";

export default function CookiePolicy() {
  return (
    <main className="flex min-h-screen flex-col">
      <SEO 
        title="Cookie Policy | How We Use Cookies on Our Website"
        description="Detailed information about how London Secondary Glazing uses cookies, tracking technologies, and your privacy choices. Manage cookie preferences and understand data collection practices."
        canonical="https://www.londonsecondaryglazing.co.uk/cookie-policy"
        keywords="cookie policy, cookies, tracking, privacy preferences, data collection, website cookies"
      />
      <Navbar />
      <div className="container mx-auto px-4 py-16 flex-grow">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold mb-8 text-primary">Cookie Policy</h1>
          <div className="prose max-w-none">
            <p className="mb-4">Last updated: {new Date().toLocaleDateString()}</p>
            
            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">1. What Are Cookies</h2>
              <p>Cookies are small text files that are placed on your computer or mobile device when you visit our website. They help us provide you with a better website experience and recognize your preferences on subsequent visits.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">2. How We Use Cookies</h2>
              <p>We use cookies to:</p>
              <ul className="list-disc pl-6 mt-4">
                <li>Understand how you use our website</li>
                <li>Remember your preferences</li>
                <li>Improve your experience</li>
                <li>Analyze website performance</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">3. Managing Cookies</h2>
              <p>You can control and manage cookies in your browser settings. Please note that removing or blocking cookies may impact your user experience on our website.</p>
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </main>
  );
}
